'use client';

import { ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { useInstantSearch } from 'react-instantsearch';

interface Props {
  children?: ReactNode;
}

export function LoadingBoundary({ children = <p>Loading search results</p> }: Props) {
  const { isLoading } = useInstantSearchLoading();

  if (isLoading) {
    return children;
  }

  return null;
}

export const useInstantSearchLoading = () => {
  const { results, status, ...rest } = useInstantSearch();

  const [isLoading, setIsLoading] = useState(() => {
    return !!(
      // status === 'loading' ||
      (status === 'stalled' || !results || results.__isArtificial)
    );
  });
  const prevIsLoadingRef = useRef(isLoading);

  useEffect(() => {
    const newIsLoading = !!(status === 'loading' || status === 'stalled' || !results || results.__isArtificial);

    if (prevIsLoadingRef.current !== newIsLoading) {
      prevIsLoadingRef.current = newIsLoading;
      setIsLoading(newIsLoading);
    }
  }, [status, results]);

  return { isLoading, results, status, ...rest };
};

export const useInstantSearchLoadingStore = () => {
  const { results, status, ...rest } = useInstantSearch();

  const isLoading = useMemo(() => {
    return status === 'loading' || status === 'stalled';
  }, [status]);

  return { isLoading, results, status, ...rest };
};
